
import useColor from '~/composable/useColor';
export default {
  props: {
    infoBanners: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { getBackground } = useColor()

    return {
      getBackground
    }
  }
}
